import { useEffect } from 'react';
import { graphql, readInlineData } from 'relay-runtime';

import { CHARGE_STATUS_ENUM } from '@woovi/shared';

import type { useMeta_charge$key } from './__generated__/useMeta_charge.graphql.ts';

type FbqPurchaseEvent = {
  value: number;
  currency: string;
  eventID: string;
};

type useMetaWindow = Window & {
  fbq?: (type: string, event: string, values: FbqPurchaseEvent) => void;
};

type useMetaProps = {
  charge: useMeta_charge$key;
};

export const useMeta = (props: useMetaProps): void => {
  const charge = readInlineData(
    graphql`
      fragment useMeta_charge on Charge @inline {
        status
        value
        identifier
        metaPixel {
          token
        }
      }
    `,
    props.charge,
  );

  const token = charge?.metaPixel?.token;

  useEffect(() => {
    if (!token) {
      return;
    }

    if (charge?.status === CHARGE_STATUS_ENUM.COMPLETED) {
      const pixelFn = (window as unknown as useMetaWindow).fbq;

      if (typeof window !== 'undefined' && typeof pixelFn === 'function') {
        pixelFn('track', 'Purchase', {
          value: charge.value! / 100,
          currency: 'BRL',
          eventID: charge.identifier!,
        });
      }
    }
  }, [charge?.status]);

  return;
};
